import { IDataSettingState } from '@/redux/slice/settings.slice';
import styled from 'styled-components';
import { appCss, estimatedShippingCss, frontendCss, mainControllerCss } from './storefrontCss';
interface IProps {
  top: number;
  generalSetting: IDataSettingState;
  isInSmallPage?: boolean;
}

export const PreviewStyled = styled.div<IProps>`
  overflow: anywhere;
  word-break: break-word;
  position: sticky;
  top: ${(props) => props.top + 'px'};
  height: fit-content;

  > .Polaris-ShadowBevel,
  > .Polaris-ShadowBevel > .Polaris-Box {
    overflow: visible;
    border-radius: 12px;
  }
  .preview-header {
    background: #333;
    color: #fff;
    padding: 8px 1rem;
    text-align: center;
    border-radius: 12px 12px 0 0;
    .preview-button-group {
      display: flex;
      gap: 4px;
      .Polaris-Icon svg * {
        fill: #fff;
      }
      .Polaris-Button {
        border: 0.49px solid rgba(255, 255, 255, 0.5);
        color: #fff;
      }
      .Polaris-Select__Backdrop,
      .Polaris-Select:hover .Polaris-Select__Backdrop {
        background-color: transparent;
      }

      .Polaris-Select__SelectedOption {
        display: none;
      }

      @media ((min-width: 768px) and (max-width: 992px)) or (max-width: 576px) {
        .mode-light {
          display: none;
        }
      }
    }
  }
  .preview-content {
    /* set width and height by pixel to optimize CLS */
    border-radius: 0 0 12px 12px;
    padding: 1rem;
    &-image-left {
      width: 30% !important;
      max-width: ${(props) => (props.isInSmallPage ? '100px' : '84px')} !important;
      /* height: ${(props) => (props.isInSmallPage ? '100px' : '84px')}; */
      /* object-fit: contain; */
      user-select: none;
      pointer-events: none;
    }
    &-image-right {
      font-size: 16px;
      padding: 0 0.5rem;
      flex-grow: 1;
      color: #b7b7b7;
      background: #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      user-select: none;
      font-weight: 650;
    }
    &.dark-mode {
      background: #1a1a1a;
      color: #ffffff;
      .Polaris-Icon__Svg {
        fill: #ffffff;
      }
      .Polaris-Button.Polaris-Button--disabled {
        background: #333;
        color: #fff;
      }
    }
    &.light-mode {
      .Polaris-Button:not(.Polaris-Button--plain) .Polaris-Button__Content {
        color: #303030;
      }
    }
    .Polaris-Icon {
      width: 20px;
      height: 20px;
    }
  }
  .est-text {
    overflow: hidden;
    line-height: normal;
  }
  .country-select {
    border: 1px solid #ccc;
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
    width: 49%;
    color: #000 !important;
  }
  .zipcode-check-shipping {
    padding-left: 4px;
    padding-bottom: 4px;
  }
  .zipcode-search-input {
    max-width: 70%;
  }
  .zipcode-search-input .Polaris-TextField__Input {
    color: ${(props) => props.generalSetting.text_color};
    caret-color: ${(props) => props.generalSetting.text_color};
  }
  .zipcode-submit-button {
    border: none;
    border-radius: 5px;
    padding: 8px 10px;
    cursor: pointer;
  }
  .se-component.se-image-container {
    display: inline-block;
    figure {
      margin: 0;
    }
  }
  .text-gray {
    color: #757575;
  }
  ${() => appCss}
  ${() => estimatedShippingCss}
  ${() => frontendCss}
  ${(props) => mainControllerCss(props.generalSetting)}
  ${(props) => props.generalSetting.custom_css}
`;
